import GradientCalculatorOptions from './GradientCalculatorOptions';

export default GradientCalculatorOptions;
